// extracted by mini-css-extract-plugin
export default {"uppload":"UpploadBtn_uppload__HzlCj","active":"UpploadBtn_active__k3b3c","disabled":"UpploadBtn_disabled__uxdRG"};